import { get } from '@api/api';
import { IUser } from './types/IUser';

export function getUsersByOrg(id: string) {
  return get<IUser[]>(`/organization/${id}/users`);
}
